import { format, startOfDay } from "date-fns";
import type { MetadataEvent } from "../hooks/useMetadataEvents";

export const withEmptyEventDays = <T extends { date: string }>(
  buckets: T[],
  events: MetadataEvent[],
): (T | { date: string })[] => {
  const existing = new Set(buckets.map((bucket) => bucket.date));
  const missing = [
    ...new Set(
      events
        .map((event) => format(startOfDay(event.occurredAt), "yyyy-MM-dd"))
        .filter((date) => !existing.has(date)),
    ),
  ];

  if (missing.length === 0) {
    return buckets;
  }

  return [...buckets, ...missing.map((date) => ({ date }))].sort((a, b) =>
    a.date.localeCompare(b.date),
  );
};
